import React, { ReactNode } from "react";
import * as BoxModule from "@mui/material/Box/index.js";
import * as TypographyModule from "@mui/material/Typography/index.js";
import * as useMediaQueryModule from "@mui/material/useMediaQuery/index.js";
import { resolveDefault } from "../utils/moduleInterop";

const Box = resolveDefault<any>(BoxModule);
const Typography = resolveDefault<any>(TypographyModule);
const useMediaQuery = resolveDefault<any>(useMediaQueryModule);

interface ResponsiveTypographyProps {
	children: ReactNode;
}

const ResponsiveTypography: React.FC<ResponsiveTypographyProps> = ({
	children,
}) => {
	const isMobile = useMediaQuery("(max-width:600px)");

	const fontSize = isMobile ? "16px" : "24px";

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				py: 1,
			}}
		>
			<Typography sx={{ fontSize: fontSize, fontWeight: "bold" }}>
				{children}
			</Typography>
		</Box>
	);
};

export default ResponsiveTypography;
